<script>
export default {
  name: 'classImg',
  data() {
    return {
      username: localStorage.getItem('name'),
      loading: true,
      tableData: [],
      optionProps: {
        id: "id",
        title: "value",
        label: "label",
        value: "label",
        children: "items"
      },
    }
  },
  beforeMount() {
    this.getClassSort()
  },
  methods: {
    getClassSort() {
      this.loading = true
      this.$axios.get("/admin/stock/classSort").then((res) => {
        this.tableData = res.data.data
        this.loading = false
      })
    },
    OpenDetail(row, column, event) {
      if (event.currentTarget.querySelector(".el-table__expand-icon")) {
        event.currentTarget.querySelector(".el-table__expand-icon").click()
      }
    },
    success(response, file, fileList, row) {
      this.$axios.post("/admin/classImg", {
        code: row.code,
        id: row.id,
        img: response
      }).then((r) => {
        this.$message.success("上传成功")
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "分类图片管理",
          "name": this.username,
          "content": "设置了'" + row.id + "'的图片"
        })
        this.getClassSort()
      }).catch((e) => {
        this.$message.error("上传失败")
      })
    },
    error() {
      this.$message.error("上传失败")
      this.$alert('请上传图片类型文件，或图片过大，图片最大为1MB，请使用画图工具将图片尺寸调小至1000像素以内', '上传失败', {
        confirmButtonText: '确定',
      });
    },
    out() {
      this.$router.push({name: 'login'})
    }
  }
}
</script>
<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>分类图片管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
    </el-header>
    <el-main class="el-main">
      <el-table
          id="listTable"
          v-loading="loading"
          @row-click="OpenDetail"
          :data="tableData"
          border
          row-key="id"
          highlight-current-row
          current-row-key="id"
          :tree-props="{ children: 'children'}"
          max-height="600">
        <el-table-column prop="code" label="分类编号" align="center" width="110">
        </el-table-column>
        <el-table-column prop="name" label="分类名称" align="center" width="300">
        </el-table-column>
        <el-table-column prop="image" label="图片" width="600">
          <template slot-scope="scope">
            <el-upload
                v-if="scope.row.depth==2"
                class="avatar-uploader"
                action="/admin/img"
                :show-file-list="false"
                :on-error="error"
                :on-success="(response, file, fileList) => {
          return success(response, file, fileList, scope.row);
        }">
              <img v-if="scope.row.img" :src="'/image/'+scope.row.img" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </div>
</template>
<style scoped>
.el-header {
  padding-top: 30px;
  margin-left: 25px;
}

.el-main {
  margin-left: 25px;
}

/deep/ .el-table__row--level-0 {
  background-color: rgb(237, 245, 255);
}

.avatar-uploader {
  .avatar-uploader .el-upload {
    border: 1px solid #000000;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/classImgView.vue